import { render } from "./LeaveApprovalSetting.vue?vue&type=template&id=99465dde"
import script from "./LeaveApprovalSetting.vue?vue&type=script&lang=js"
export * from "./LeaveApprovalSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__